import script from "./ExclusionSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ExclusionSettings.vue?vue&type=script&setup=true&lang=js"

import "./ExclusionSettings.vue?vue&type=style&index=0&id=0bb64e28&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bb64e28"]])

export default __exports__